import { Link } from 'react-router-dom';
import { SquareTerminalIcon } from 'lucide-react';
import type { Endpoint } from '@mockd/shared';
import { EmptyState } from '../common/EmptyState';
import { StatusBadge } from '../common/StatusBadge';

interface EndpointListProps {
  projectId: string;
  endpoints: Endpoint[];
  emptyAction?: React.ReactNode;
}

export function EndpointList({ projectId, endpoints, emptyAction }: EndpointListProps) {
  if (endpoints.length === 0) {
    return (
      <EmptyState
        icon={
          <SquareTerminalIcon className="size-6" />
        }
        title="No endpoints yet"
        description="Create an endpoint to define how your mock API responds to requests."
        action={emptyAction}
      />
    );
  }

  return (
    <div className="card bg-base-100 overflow-hidden">
      <div className="divide-y divide-base-200">
        {endpoints.map(endpoint => (
          <Link
            key={endpoint.id}
            to={`/projects/${projectId}/endpoints/${endpoint.id}`}
            className="flex items-center gap-3 px-4 py-3 hover:bg-base-200 transition-colors"
          >
            <StatusBadge status={endpoint.statusCode} />
            <span className="text-sm font-mono text-primary flex-1 truncate">{endpoint.path}</span>
            <div className="flex items-center gap-3 text-xs text-base-content/70 shrink-0">
              {endpoint.delay > 0 && (
                <span title="Response delay">{endpoint.delay}ms</span>
              )}
              <span title="Rate limit">{endpoint.rateLimit} req/min</span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
